import Dialog from 'src/components/modal/Dialog.vue';

let VueComponent;
let component;

export function close() {
  if (!component) return;
  component.show = false;
  component.$destroy();
}

export function show(title, params = {}) {
  const localParams = Object.assign(
    {
      type: 'success', // success|danger|neutral
      size: 'sm',
      closable: true,
      html: null,
      buttons: null,
    },
    params,
  );

  component = new VueComponent();

  component.show = true;
  component.title = title;
  component.type = localParams.type;
  component.closable = localParams.closable;
  component.html = localParams.html;
  component.buttons = localParams.buttons;
  component.size = localParams.size;
  component.$on('close', close);

  component.$mount();
}

export default function install(Vue) {
  VueComponent = Vue.extend(Dialog);

  Object.defineProperty(Vue.prototype, '$dialog', {
    get() {
      return { show, close };
    },
  });
}
